import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import CustomWhatsapp from '../General/CustomWhatsapp';
import ChatWindow from '../ChatWindow/ChatWindow';
import styles from './WhatsappComponent.module.scss';

export default function WhatsappComponent() {
  const [showMenu, setShowMenu] = useState(false);
  const timerRef = useRef(null);

  // Configuración fija para Perú
  const phoneNumber = '5112131330';
  const message =
    '¡Hola! Vengo desde la web oficial de Zoomlion Perú. Quiero hacerte una consulta.';

  // Hover sobre el botón: tras 1s abre menú
  const handleButtonMouseEnter = () => {
    timerRef.current = setTimeout(() => {
      setShowMenu(true);
    }, 1000);
  };
  const handleButtonMouseLeave = () => {
    clearTimeout(timerRef.current);
  };

  // Salir de la ventana de chat la cierra
  const handleChatMouseLeave = () => {
    setShowMenu(false);
  };

  const handleClick = () => {
    const formatted = phoneNumber.replace(/\D/g, '');
    const encoded = encodeURIComponent(message).replace(/%20/g, '+');
    const url1 = `https://api.whatsapp.com/send?phone=${formatted}&text=${encoded}`;
    const url2 = `https://wa.me/${formatted}?text=${encoded}`;
    window.open(url1, '_blank', 'noopener') ||
      window.open(url2, '_blank', 'noopener');
  };

  return (
    <div className={styles.container}>
      {showMenu && (
        <ChatWindow
          onClose={() => setShowMenu(false)}
          onOpen={handleClick}
          onMouseLeave={handleChatMouseLeave}
        />
      )}

      <motion.div
        className={styles.whatsappWrapper}
        onMouseEnter={handleButtonMouseEnter}
        onMouseLeave={handleButtonMouseLeave}
        whileHover={{ scale: 1.1, y: -5 }}
        transition={{ type: 'spring', stiffness: 300 }}
        style={{ display: 'inline-block', cursor: 'pointer' }}
      >
        <CustomWhatsapp
          onClick={handleClick}
          className={styles.whatsappButton}
        />
      </motion.div>
    </div>
  );
}
